export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.0a5e990a.woff";